import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { buildOpsMenuTree } from './ops-menu-tree';

@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  private sidebarVisible = new BehaviorSubject<boolean>(false);
  sidebarVisibility$ = this.sidebarVisible.asObservable();
  private menbarVisible = new BehaviorSubject<boolean>(false);
  menubarVisibility$ = this.menbarVisible.asObservable();

  constructor(private http: HttpClient,){}

  // Method to show the sidebar
  showSidebar() {
    this.sidebarVisible.next(true);
  }

  // Method to hide the sidebar
  hideSidebar() {
    this.sidebarVisible.next(false);
  }
  
  showMenubar() {
    this.menbarVisible.next(true);
  }

  hideMenubar() {
    this.menbarVisible.next(false);
  }
  
	fetchMenu(){
		// Dynamic API (90001/OpsUiMenu); buildOpsMenuTree rebuilds the legacy { data: tree } shape.
		return this.http.post(environment.OPS_Dynamic_API_BASE_URL + "/90001/OpsUiMenu", {})
			.pipe(map((res: any) => ({ data: buildOpsMenuTree(res?.Table1 || []) })));
	}
}